import React, { useEffect, useState } from 'react';

import { ActionButton, ActionLink } from '@eika/button';
import { ViewType } from '@eika/hooks';
import { IconTypes } from '@eika/icon';

import CreateAvtaleGiro from '../../components/transaction/AvtaleGiro/CreateAvtaleGiro';
import { useConfig } from '../../defaultConfig';
import { useRefreshAvtalegiro } from '../../fetchHooks/useAvtalegiro';
import useHasView from '../../hooks/useHasView';
import useReceiverAccount from '../../hooks/useReceiverAccount';
import useTranslation from '../../hooks/useTranslation';
import { ANALYTICS_START, AnalyticsEvents, trackEvent } from '../../services/analytics';
import { paymentTrackIDs } from '../../utils/gtm/trackIDs/payment';
import { ANALYTICS_CATEGORY_USABLE } from '../AvtaleGiro/AvtaleGiro';
import useAvtaleGiroKid from './useAvtaleGiroKid';

import './AvtalegiroActions.scss';

interface Props {
    views?: ViewType[];
}

const AvtalegiroActions: React.FC<Props> = ({ views = [ViewType.desktop] }) => {
    const isVisible = useHasView(views);
    const [showAvtaleGiroModal, setAvtaleGiroModal] = useState<boolean>(false);
    const receiver = useReceiverAccount();
    const kid = useAvtaleGiroKid();
    const translated = useTranslation();
    const { featureToggles, fetchAvtalegiroLink } = useConfig();

    const refreshAvtalegiro = useRefreshAvtalegiro();

    useEffect(() => {
        if (showAvtaleGiroModal) {
            trackEvent(AnalyticsEvents.AVTALEGIRO, ANALYTICS_CATEGORY_USABLE, ANALYTICS_START);
        }
    }, [showAvtaleGiroModal]);

    useEffect(() => {
        if (receiver || kid) {
            setAvtaleGiroModal(true);
        }
    }, [receiver, kid]);

    if (!isVisible) return <></>;

    return (
        <>
            <div id="avtalegiro-action-button" className="action-button-group avtalegiro__button-row">
                <ActionButton
                    icon={IconTypes.FAKTURA_36}
                    className="avtalegiro__button--new"
                    onClick={() => setAvtaleGiroModal(true)}
                    data-track-id={paymentTrackIDs.avtalegiro.createAvtalegiro}
                    data-track-linkname={translated.avtaleGiroAgreement.newAvtaleGiro}
                >
                    {translated.avtaleGiroAgreement.newAvtaleGiro}
                </ActionButton>
                {featureToggles.enableFetchAvtalegiros && fetchAvtalegiroLink && (
                    <ActionLink
                        icon={IconTypes.COPY_36}
                        className="avtalegiro__button--new"
                        href={fetchAvtalegiroLink.url}
                        data-track-id={paymentTrackIDs.avtalegiro.moveAvtalegiros}
                        data-track-linkname={translated.avtaleGiroAgreement.retriveAvtaleGiro}
                    >
                        {translated.avtaleGiroAgreement.retriveAvtaleGiro}
                    </ActionLink>
                )}
            </div>

            <CreateAvtaleGiro
                show={showAvtaleGiroModal}
                setShow={setAvtaleGiroModal}
                refresh={refreshAvtalegiro}
                receiver={receiver}
                kid={kid}
            />
        </>
    );
};
export default AvtalegiroActions;
